#import "../fragments/email-sequence-fragment.graphql"

mutation SendQueuedEmailNow($payload: EmailQueuedSendNowInput!) {
    emailQueuedSendNow(input: $payload) {
        emailSequence {
            ...EmailSequenceFragment
        }
    }
}
